import Config from 'Config';

import { createApiClient } from '../api-client-factory';

import {
  ActivateProductRequest,
  CreateOrganizationRequest,
  CreateOrganizationResponse,
  DomainsResponse,
  Organization,
} from './types';

const client = createApiClient(`${Config.accounts_api_url}/v2/organizations`);

/**
 * Organizations API client.
 */
export const organizationsClient = {
  /**
   * Get avaliable products details.
   */
  create: async (data: CreateOrganizationRequest) => {
    const queryParams = {
      client_id: Config.client_id,
      redirect_uri: Config.redirect_uri,
      response_type: Config.response_type,
      state: Config.state,
      prompt: Config.prompt,
      code_challenge: Config.code_challenge,
      code_challenge_method: Config.code_challenge_method,
      organization_id: Config.organization_id,
      scope: Config.scope,
      restore_id: Config.restore_id,
    };

    const queryString = Object.keys(queryParams)
      .filter((key) => queryParams[key] !== undefined && queryParams[key] !== null)
      .map((key) => `${key}=${queryParams[key]}`)
      .join('&');

    return client.post<CreateOrganizationResponse>(`?${queryString}`, data);
  },

  activateProduct: async (data: ActivateProductRequest, token: string) =>
    client.post('my/products', data, token),

  getMy: async (token: string) => client.get<Organization>('my', token),

  getMyDomains: async (token: string) => client.get<DomainsResponse>('my/domains', token),
};
